import React, { useMemo, useState, useContext } from 'react';

import PropTypes from 'prop-types';

const Context = React.createContext();

export function useProductBrowserFilterState() {
  return useContext(Context);
}

export default function ProductBrowserFilterContext({ children }) {
  const [filters, setFilters] = useState(null);
  const [sort, setSort] = useState(null);

  const value = useMemo(
    () => ({
      filters,
      setFilters,
      sort,
      setSort,
    }),
    [filters, sort]
  );

  return (
    <Context.Provider value={value}>
      {typeof children === 'function' ? children(value) : children}
    </Context.Provider>
  );
}

ProductBrowserFilterContext.propTypes = {
  children: PropTypes.any,
};

ProductBrowserFilterContext.Context = Context;
